// eslint-disable-next-line import/prefer-default-export
export const capitalizeFirstLetter = (s: string) =>
  s.charAt(0).toUpperCase() + s.slice(1);
